export default async function loaderStart({ context, nextMiddleware }) {
  try {
    await context.store.dispatch('setLoader', { show: true, manual: true });
  } catch (e) {
    console.error(e);
    return context.next(false);
  }
  return nextMiddleware();
}
